import AnimatedShaderHero from './ui/animated-shader-hero';
import { useNavigate } from 'react-router';
import { useSiteConfig, resolveUploadUrl } from '../utils/siteConfig';
import { AnimatedNumber } from './AnimatedNumber';

export function Hero() {
  const navigate = useNavigate();
  const { config, openGetStarted } = useSiteConfig();

  const handlePrimaryClick = () => {
    openGetStarted();
  };

  const handleSecondaryClick = () => {
    navigate('/portfolio');
  };

  return (
    <>
      <AnimatedShaderHero
        videoUrl={resolveUploadUrl(config.home.hero.videoUrl)}
        trustBadge={{
          text: config.home.hero.trustBadgeText,
          icons: ["✨", "🚀"]
        }}
        headline={{
          line1: config.home.hero.headlineLine1,
          line2: config.home.hero.headlineLine2
        }}
        subtitle={config.home.hero.subtitle}
        buttons={{
          primary: {
            text: config.home.hero.primaryBtnText,
            onClick: handlePrimaryClick
          },
          secondary: {
            text: config.home.hero.secondaryBtnText,
            onClick: handleSecondaryClick
          }
        }}
      />
      {/* Additional Stats Section */}
      <div className="bg-slate-50 py-8 md:py-16 px-4 md:px-8 relative z-10 border-b border-slate-200">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {config.home.stats.map((stat, index) => (
              <div
                key={index}
                className="p-6 bg-white rounded-2xl border border-slate-200 shadow-sm text-center hover:shadow-xl hover:shadow-primary/5 hover:border-primary transition-all hover:-translate-y-1 duration-300"
              >
                <div className="text-4xl mb-2 font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent flex justify-center">
                  <AnimatedNumber value={stat.number} />
                </div>
                <div className="text-sm text-slate-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
